import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  OnDestroy
} from '@angular/core';
import { SpinnerService } from '../service/spinner.service';
import { Subscription } from 'rxjs';
import { SharedModule } from '../module/shared.module';

@Component({
  selector: 'app-progress-spinner',
  templateUrl: 'progress-spinner.html',
  styleUrls: ['progress-spinner.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class ProgressSpinnerComponent implements OnDestroy, AfterContentInit {
  public showSpinner = false;
  private unsubscribe: Subscription[] = [];
  constructor(
    private spinnerService: SpinnerService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnDestroy() {
    this.unsubscribe.forEach((s) => s.unsubscribe());
  }

  ngAfterContentInit() {
    this.unsubscribe.push(
      this.spinnerService.visibility.subscribe((spin) => {
        this.showSpinner = spin;
        this.cdRef.detectChanges();
      })
    );
  }
}
